<template>
  <v-row>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        avatarClass="mr-5 mt-7"
        avatarSize="50"
        :img="assets.projectProgress"
        :isOverdue="isOverdue"
        :quantity="isOverdue ? 100 : dashboard.progression"
        quantityUnit="%"
        :title="$tc('categories.incoming_tasks.new_name', 2)"
        :to="toProjectTaskEdit"
      />
    </v-col>

    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        avatarClass="mr-5 mt-7"
        avatarSize="50"
        :img="assets.projectTasksRemaining"
        :quantity="dashboard.actions_kpi"
        :title="$tc('categories.nonconformity.action.name', 2)"
        :to="toAllProjectActions"
      />
    </v-col>

    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        avatarClass="mr-5 mt-7"
        avatarSize="50"
        :img="assets.projectInspectionsRemaining"
        :quantity="dashboard.inspections_kpi"
        :title="$t('categories.inspection.in_progress')"
        :to="toInspections"
      />
    </v-col>
    <v-col
      cols="12"
      lg="3"
    >
      <kpi-card-component
        avatarClass="mr-5 mt-7"
        avatarSize="50"
        :img="assets.projectNonconformities"
        :quantity="dashboard.non_conformities_kpi"
        :title="$tc('categories.nonconformity.name', 2)"
        :to="toNonConformities"
      />
    </v-col>
  </v-row>
</template>

<script>
import KpiCardComponent from "@/components/ri3/KpiCardComponent.vue"
import { getAssets } from "@/plugins/vuetify"

export default {
  name: "ProjectKPI",
  components: {
    KpiCardComponent
  },
  props: {
    dashboard: {
      type: Object
    },
    projectId: {
      type: String,
      required: true
    }
  },
  computed: {
    assets() {
      return getAssets(this)
    },
    isOverdue() {
      return this.dashboard.progression > 100
    }
  },
  data() {
    return {
      toInspections: { name: "Inspections" },
      toNonConformities: { name: "NonConformities" },
      toProjectGantt: { name: "Gantt" },
      toProjectTaskEdit: {
        name: "ProjectCreateUpdate",
        params: { id: this.projectId, tab: 2 }
      },
      toAllProjectActions: { name: "AllProjectActions" }
    }
  }
}
</script>
